import { Component, inject, OnInit, signal } from '@angular/core';
import { form, required } from '@angular/forms/signals';
import { FormField } from '@angular/forms/signals';
import { AddDocumentComponent } from '../../../../atoms/add-document/add-document.component';
import { ScreeningListResponseDto } from '../../../../common/general-types/social-screening.dto';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';
import { DatePipe } from '@angular/common';
import { CreateScreeningService } from '../../services/create-screening/create-screening.service';

@Component({
  selector: 'screening-creators',
  standalone: true,
  imports: [FormField, AddDocumentComponent, DatePipe],
  templateUrl: './creators.component.html',
  styleUrl: './creators.component.css'
})
export class ScreeningCreatorsComponent implements OnInit {

  addCreatorOptions: { id: number, name: string, description: string, class: string }[] = [
    { id: 1, name: `Select Later`, description: `i'll select creators later...`, class: 'bg-teal-500/10 text-teal-400' },
    { id: 2, name: `Add Manually`, description: `Enter creator details one by one.`, class: 'bg-rose-500/10 text-rose-400' },
    { id: 3, name: `Upload CSV`, description: `Upload a CSV using a template.`, class: 'bg-blue-500/10 text-blue-400' },
    { id: 4, name: `Existing List`, description: `Use an existing list of creators.`, class: 'bg-pink-500/10 text-pink-400' },
  ]

  selectedAddCreatorOption = signal<{ id: number, name: string, description: string } | undefined>(undefined);


  /** Crator List Values */
  creatorListModel = signal({
    listName: '',
    listDescription: '',
    googleDocUrl: '',
  })
  creatorListForm = form(this.creatorListModel, (schemaPath) => {
    required(schemaPath.listName, { message: 'List name is required' });
    required(schemaPath.listDescription, { message: 'List description is required' });
  })

  allLists = signal<ScreeningListResponseDto[]>([]);
  /** Crator List Values - END */

  /** Creators Table */
  creators = signal<{creatorName: string, instagram: string, tiktok: string}[]>([]);
  /** Creators Table - END */

  /** Services */
  private socialScreeningService = inject(SocialScreeningService);
  private currentUserService = inject(CurrentUserService);
  public createScreeningService = inject(CreateScreeningService);
  /** Services - END */

  ngOnInit(): void {
    this.getSocialScreeningLists();
  }

  getSocialScreeningLists() {
    this.socialScreeningService.getBusinessAccountSocialScreeningLists(this.currentUserService.focussedBrand.id).subscribe((response) => {
      console.log('Social Screening Lists:', response);
      this.allLists.set(response as ScreeningListResponseDto[]);
    });
  }

  selectList(list: ScreeningListResponseDto) {
    this.createScreeningService.selectedList.set(list);
  }

  selectAddCreatorOption(option: { id: number, name: string, description: string }) {
    console.log('selectAddCreatorOption', option);
    this.selectedAddCreatorOption.set(option);
    // Initialize with one empty row when manual option is selected
    if (option.id === 2 && this.creators().length === 0) {
      this.creators.set([{ creatorName: '', instagram: '', tiktok: '' }]);
    }
  }

  addCreatorRow() {
    this.creators.update(creators => [...creators, { creatorName: '', instagram: '', tiktok: '' }]);
  }

  removeCreatorRow(index: number) {
    this.creators.update(creators => creators.filter((_, i) => i !== index));
  }

  updateCreatorField(index: number, field: 'creatorName' | 'instagram' | 'tiktok', value: string) {
    this.creators.update(creators => {
      const updated = [...creators];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  }

  getCreatorsArray(): {creatorName: string, instagram: string, tiktok: string}[] {
    return this.creators().filter(c => c.creatorName.trim() || c.instagram.trim() || c.tiktok.trim());
  }

  onDocumentUploaded(event: { file: string, fileKey: string, fullUrl: string }) {
    this.creatorListModel.update(model => ({ ...model, googleDocUrl: event.fullUrl }));
  }

}
